// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { handleApiCall } from "../utils/apiHelper";

const tenantParams = (tenantId) => ({ tenant_id: tenantId });

const gdprService = {
  getGDPRStatus: (tenantId) =>
    handleApiCall(
      () => apiClient.get("/admin/status", { params: tenantParams(tenantId) }),
      "Error fetching GDPR status",
    ),

  getRetentionPolicies: (tenantId) =>
    handleApiCall(
      () =>
        apiClient.get("/admin/retention-policies", {
          params: tenantParams(tenantId),
        }),
      "Error fetching retention policies",
    ),

  createRetentionPolicy: (_tenantId, policyData) =>
    handleApiCall(
      () => apiClient.post("/admin/retention-policies", policyData),
      "Error creating retention policy",
    ),

  updateRetentionPolicy: (policyId, policyData) =>
    handleApiCall(
      () => apiClient.put(`/admin/retention-policies/${policyId}`, policyData),
      "Error updating retention policy",
    ),

  getDeletionLogs: (tenantId) =>
    handleApiCall(
      () =>
        apiClient.get("/admin/deletion-logs", {
          params: tenantParams(tenantId),
        }),
      "Error fetching deletion logs",
    ),

  deleteUserData: (userId) =>
    handleApiCall(
      () => apiClient.delete("/admin/user", { params: { user_id: userId } }),
      "Error deleting user data",
    ),

  exportUserData: (userId) =>
    handleApiCall(
      () =>
        apiClient.get("/admin/user/export", { params: { user_id: userId } }),
      "Error exporting user data",
    ),
  downloadExport: (logId) =>
    handleApiCall(
      () => apiClient.get(`/admin/download/${logId}`, { responseType: "blob" }),
      "Error downloading export",
    ),

  triggerCleanup: (tenantId) =>
    handleApiCall(
      () =>
        apiClient.post("/admin/cleanup", { params: tenantParams(tenantId) }),
      "Error triggering cleanup",
    ),

  initializeGDPRSystem: (tenantId) =>
    handleApiCall(
      () =>
        apiClient.post("/admin/initialize", { params: tenantParams(tenantId) }),
      "Error initializing GDPR system",
    ),

  getAuditLogs: (tenantId) =>
    handleApiCall(
      () =>
        apiClient.get("/admin/audit-logs", { params: tenantParams(tenantId) }),
      "Error fetching audit logs",
    ),

  getDataRecords: (tenantId, limit = 25, page = 1) => {
    const offset = (page - 1) * limit;
    return handleApiCall(
      () =>
        apiClient.get("/admin/data-records", {
          params: { tenant_id: tenantId, limit, page, offset },
        }),
      "Error fetching data records",
    );
  },
};

export default gdprService;
